"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Retry_1 = require("../../Abr/Retry");
var CONFIG_RETRY_1 = require("../Constants/CONFIG_RETRY");
function createRetry() {
    var retry = new Retry_1.default();
    retry.configure(CONFIG_RETRY_1.default);
    return retry;
}
exports.default = createRetry;
//# sourceMappingURL=createRetry.js.map